<template>
  <FormulateInput
    type="smartselect"
    v-model="_value"
    v-bind="$attrs"
    :label="label"
    :validation="validation"
    :smartOptions="options"
    :trackBy="trackBy"
    :searchable="searchable"
    :multiple="multiple"
    :showLabels="showLabels"
    :placeholder="placeholder"
    data-lpignore="true"
    @object="(val) => $emit('object', val)"
  />
</template>

<script>
export default {
  name: 'FormSelect',
  inheritAttrs: false,
  props: {
    /**
     * Current value of select component.
     * @model
     */
    value: {
      type: [Number, String, Array, Object],
      default: () => ''
    },
    /**
     * Array of available options: Objects, Strings or Integers. If array of objects, visible label will default to option.label.
     */
    options: {
      type: [Object, Array],
      required: true
    },
    /**
     * Unique field used to compare objects. Only use if options are objects.
     */
    trackBy: {
      type: String
    },
    /**
     * Disable the select as being searchable.
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Enable multi-select options.
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Label that will be visible above the dropdown.
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Decide whether to show labels on highlighted options.
     */
    showLabels: {
      type: Boolean,
      default: false
    },
    /**
     * Validation rules.
     */
    validation: {
      type: String
    },
    /**
     * String to display when no option is selected.
     */
    placeholder: {
      type: String,
      default: 'Select one'
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    async change(val) {
      // console.log('object->listener', val)
    }
  }
}
</script>
